export default "__VITE_ASSET__DwxGDIsL__"